import React from 'react';
import { Row, Col, Card, CardBody, Button, Badge, Container, Modal } from 'reactstrap';
import Datatables from 'pages/table/datatable';

const tableColumns = [
    { dataField: "id", text: "#", formatter: (cell, row, index) => index + 1 },
    { dataField: "plan", text: "Plan Name" },
    { dataField: "rate", text: "Rate" },
    { dataField: "discount", text: "Discount" },
    { dataField: "tax", text: "Tax" },
    { dataField: "amount", text: "Amount" },
];

const InvoicePreview = ({ isOpen, toggle, data }) => {
    const [modalOpen, setModalOpen] = React.useState(isOpen);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
        if (toggle) toggle();
    };

    if (!data) return null;

    const productItems = [
        { id: 1, plan: "Basic", rate: "$99.00", discount: "0%", tax: "$0.00", amount: "$99.00" },
    ];

    return (
        <Modal isOpen={modalOpen} toggle={toggleModal} style={{ maxWidth: "1000px" }} className="custom-modal" >
            <div className="modal-header">
                <h4 className="modal-title fw-bold mb-1">Invoice</h4>
                <button type="button" onClick={toggleModal} className="close" aria-label="Close"></button>
            </div>

            <Container className="p-3">
                {/* Action Buttons Bar */}
                <div className="d-flex justify-content-end gap-2 mb-3">
                    <Button color="white" className="border shadow-sm btn-sm text-muted">
                        <i className="bx bx-download me-1"></i> Download PDF
                    </Button>
                    <Button color="white" className="border shadow-sm btn-sm text-muted">
                        <i className="bx bx-send me-1"></i> Send Email
                    </Button>
                    <Button color="white" className="border shadow-sm btn-sm text-muted" onClick={() => window.print()}>
                        <i className="bx bx-printer me-1"></i> Print
                    </Button>
                </div>

                <Card className="border shadow-none overflow-hidden">
                    <CardBody className="p-0">
                        {/* Header Section */}
                        <Row className="p-4 d-flex justify-content-between align-items-center position-relative"
                            style={{ background: 'linear-gradient(90deg, #fff 70%, #f0ebff 100%)' }}>
                            <Col md="6" className="text-start">
                                <h4 className="fw-bold mb-1">Invoice</h4>
                                <p className="mb-1 text-dark fw-bold">Deal to Close Pvt Ltd.</p>
                                <p className="text-muted mb-1 small">223, Shri Punjan Plaza, Kailash Nagar Society, </p>
                                <p className="text-muted mb-1 small"> Surat, Gujarat – 395010</p>
                            </Col>

                            {/* NOT PAID STAMP */}
                            <Col xs='auto' className="position-absolute text-center" style={{ left: '45%', top: '30%' }}>
                                <div style={{
                                    border: '2px dashed #ff6b6b', color: '#ff6b6b', padding: '5px 10px', borderRadius: '5px',
                                    transform: 'rotate(-15deg)', fontWeight: 'bold', fontSize: '12px'
                                }}>
                                    NOT PAID
                                </div>
                            </Col>

                            <Col xs="auto" className="text-end">
                                <h3 className="text-dark fw-bold d-flex align-items-center">
                                    <i className="bx bxs-invader text-primary me-2"></i> Deal to Close
                                </h3>
                            </Col>
                        </Row>

                        <hr className="m-0 opacity-10" />

                        {/* Details Section (Replaces Row/Col) */}
                        <div className="p-4">
                            <div className="d-flex flex-wrap mb-4" style={{ gap: '20px' }}>
                                <div style={{ flex: '1', minWidth: '250px' }}>
                                    <h6 className="fw-bold mb-3">Invoice Details</h6>
                                    <div className="text-muted small">
                                        <p className="mb-1 text-dark">Invoice Number : <span className="text-muted">INV215654</span></p>
                                        <p className="mb-1 text-dark">Issued On : <span className="text-muted">25 Jan 2025</span></p>
                                        <p className="mb-1 text-dark">Due Date : <span className="text-muted">31 Jan 2025</span></p>
                                        <p className="mb-1 text-dark">Recurring Invoice : <span className="text-muted">Monthly</span></p>
                                        <Badge color="light" className="text-danger mt-1">Due in 6 days</Badge>
                                    </div>
                                </div>

                                {/* Billing From */}
                                <div style={{ flex: '1', minWidth: '250px' }}>
                                    <h6 className="fw-bold mb-3">Billing From</h6>
                                    <div className="small">
                                        <p className="fw-bold mb-1">Deal to Close Invoice Management</p>
                                        <p className="text-muted mb-1">223, Shri Punjan Plaza, Kailash Nagar Society, </p>
                                        <p className="text-muted mb-1">Surat, Gujarat – 395010 </p>
                                        <p className="text-muted mb-1">Phone : +1 54664 75945</p>
                                        <p className="text-muted mb-1">Email : info@example.com</p>
                                        <p className="text-muted">GST : 243E45767889</p>
                                    </div>
                                </div>

                                {/* Billing To */}
                                <div style={{ flex: '1', minWidth: '250px' }}>
                                    <Card className="border-0 bg-white shadow-sm" style={{ borderRadius: '10px' }}>
                                        <CardBody className="p-3">
                                            <h6 className="fw-bold mb-3">Billing To</h6>
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="bg-dark text-white rounded p-1 me-2" style={{ width: '30px', textAlign: 'center' }}>
                                                    <i className="bx bx-buildings"></i>
                                                </div>
                                                <span className="fw-bold">Timesquare Tech</span>
                                            </div>
                                            <div className="text-muted small">
                                                <p className="mb-1">299 Star Trek Drive, Florida, 3240, USA</p>
                                                <p className="mb-1">Phone : +1 54664 75945</p>
                                                <p className="mb-1">Email : info@example.com</p>
                                                <p className="mb-0">GST : 243E45767889</p>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>

                            <h5 className="fw-bold mb-3">Service</h5>
                            <Datatables
                                columns={tableColumns}
                                showTableOnly={true}
                                rows={productItems}
                                keyField={"id"}
                                showPagination={false}
                            />

                            {/* Footer Details Section (Replaces Row/Col) */}
                            <div className="d-flex flex-wrap mt-5" style={{ gap: '30px' }}>
                                {/* Left Side: Bank Details */}
                                <div style={{ flex: '1', minWidth: '300px' }}>
                                    <p className="text-muted mb-2 small">Scan to the pay</p>
                                    <div className="d-flex gap-3">
                                        <div className="border p-1 bg-white" style={{ width: '90px', height: '90px' }}>
                                            <img src="https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=Invoice" alt="qr" style={{ width: '100%' }} />
                                        </div>
                                        <div>
                                            <h6 className="fw-bold mb-1">Bank Details</h6>
                                            <p className="text-muted mb-0 small">Bank Name : ABC Bank</p>
                                            <p className="text-muted mb-0 small">Account Number : 782459739212</p>
                                            <p className="text-muted mb-0 small">IFSC Code : ABCD0001345</p>
                                            <p className="text-muted mb-0 small">Payment Reference : INV-20250220-001</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Side: Totals */}
                                <div style={{ flex: '1', minWidth: '300px' }}>
                                    <div className="d-flex justify-content-between mb-2 small">
                                        <span className="fw-bold">Amount</span>
                                        <span className="fw-bold">$99.00</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-muted small">
                                        <span>CGST (0%)</span>
                                        <span>$0.00</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-muted small">
                                        <span>SGST (0%)</span>
                                        <span>$0.00</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 small">
                                        <span className="text-muted">Discount (0%)</span>
                                        <span className="text-danger">- $0</span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="fw-bold mb-0">Total (USD)</h5>
                                        <h5 className="fw-bold mb-0 text-primary">$99.00</h5>
                                    </div>
                                    <div className="text-end border-top pt-2">
                                        <p className="text-muted mb-0 small">Total In Words</p>
                                        <p className="fw-bold text-dark mb-0">Ninety Nine Dollars</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Bottom Banner */}
                        <div className="p-3 d-flex justify-content-between align-items-center mt-4"
                            style={{ background: 'linear-gradient(90deg, #f8f9fa 70%, #f0ebff 100%)' }}>
                            <div className="text-muted small">
                                <p className="fw-bold mb-0 text-dark">Deal to Close Pvt Ltd.</p>
                                223, Shri Punjan Plaza, Kailash Nagar Society, Surat, Gujarat – 395010
                            </div>
                            <h4 className="text-primary fw-bold opacity-50 mb-0">
                                <i className="bx bxs-invader me-1"></i> Deal to Close
                            </h4>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </Modal>
    );
};

export default InvoicePreview;